var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "user"
  }, _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('span', [item.isUserByTree ? _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['USER']
      }
    }) : item.tagId ? _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['TAG']
      }
    }) : _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['ORG']
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])], 1), _c('Icon', {
      staticClass: "delete",
      attrs: {
        "type": "md-close"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('remove', item);
        }
      }
    })], 1);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };